const sortOption = (value, label) => ({
  value,
  label,
});

export const realEstateCommissionSupportSortOptions = t => [
  sortOption('', t('REAL_ESTATE_COMMISSION_SUPPORT.SORT.DEFAULT')),
  sortOption(
    'data_entrada_1',
    t('REAL_ESTATE_COMMISSION_SUPPORT.SORT.ENTRY_NEWEST')
  ),
  sortOption(
    'data_entrada_2',
    t('REAL_ESTATE_COMMISSION_SUPPORT.SORT.ENTRY_OLDEST')
  ),
  sortOption(
    'data_assinatura_1',
    t('REAL_ESTATE_COMMISSION_SUPPORT.SORT.SIGNATURE_NEWEST')
  ),
  sortOption(
    'data_assinatura_2',
    t('REAL_ESTATE_COMMISSION_SUPPORT.SORT.SIGNATURE_OLDEST')
  ),
  sortOption(
    'valor_comissao_1',
    t('REAL_ESTATE_COMMISSION_SUPPORT.SORT.COMMISSION_HIGH')
  ),
  sortOption(
    'valor_comissao_2',
    t('REAL_ESTATE_COMMISSION_SUPPORT.SORT.COMMISSION_LOW')
  ),
  sortOption(
    'valor_venda_1',
    t('REAL_ESTATE_COMMISSION_SUPPORT.SORT.SALE_HIGH')
  ),
  sortOption(
    'valor_venda_2',
    t('REAL_ESTATE_COMMISSION_SUPPORT.SORT.SALE_LOW')
  ),
];
